import request from "@/utils/request";
import UploadOSSUtil from "@/utils/uploadOSS";

// 获取二级列表
export function publics(data, url) {
  return request({
    url,
    method: "post",
    data
  });
}

//文件图片上传
export function uploadFile(data) {
  return UploadOSSUtil.uploadOSS(data.raw);
  // return request({
  //   url: "", //接口地址
  //   headers: {
  //     "Content-Type": "multipart/form-data"
  //   },
  //   method: "post",
  //   data
  // });
}

// 获取论坛类型
export function SearchForumTypeInfoList(data) {
  return request({
    url: "/api/ForumMethod/SearchForumTypeInfoList",
    method: "post",
    data
  });
}

// 查询宠物类型
export function SearchPetTypeInfoList(data) {
  return request({
    url: "/api/ForumMethod/SearchPetTypeInfoList",
    method: "post",
    data
  });
}

// 查询讲师列表
export function SearchLeturerInfoList(data) {
  return request({
    url: "/api/LecturerMethod/SearchLeturerInfoList",
    method: "post",
    data
  });
}

// 查询课程分类
export function SearchClassTypeInfoList(data) {
  return request({
    url: "/api/ClassMethod/SearchClassTypeInfoList",
    method: "post",
    data
  });
}

// 查询课程首页推荐类型
export function SearchHomeRecommendTypeInfoList(data) {
  return request({
    url: "/api/ClassMethod/SearchHomeRecommendTypeInfoList",
    method: "post",
    data
  });
}

// 获取BannerInfo列表
export function SearchBannerInfoList(data) {
  return request({
    url: "/api/BannerMethod/SearchBannerInfoList",
    method: "post",
    data
  });
}

// 获取权重信息
export function SearchBannerWeightMsg(data) {
  return request({
    url: "/api/BannerMethod/SearchBannerWeightMsg",
    method: "post",
    data
  });
}

// 查询Banner位置列表
export function SearchBannerPositionList(data) {
  return request({
    url: "/api/BannerMethod/SearchBannerPositionList",
    method: "post",
    data
  });
}
// 查询指定ID的评论接口;
export function SearchCommentsInfoByForumKeyID(data) {
  return request({
    url: "/api/SystemMethod/SearchCommentsInfoByForumKeyID",
    method: "post",
    data
  });
}

// 查询指定评论ID的次级评论
export function SearchSecondaryCommentsInfoByID(data) {
  return request({
    url: "/api/SystemMethod/SearchSecondaryCommentsInfoByID",
    method: "post",
    data
  });
}

// 查询指定评论ID的次级评论
export function CanNewMsgTip(data) {
  return request({
    url: "/api/SystemMethod/CanNewMsgTip",
    method: "post",
    data
  });
}

// 查询个人信息
export function SearchMyInformation(data) {
  return request({
    url: "/api/SystemMethod/SearchMyInformation",
    method: "post",
    data
  });
}
// 查询论坛
export function SearchForumInfoList(data) {
  return request({
    url: "/api/SystemMethod/SearchForumInfoList",
    method: "post",
    data
  });
}

// 查询论坛By、ID
export function SearchForumInfoByID(data) {
  return request({
    url: "/api/SystemMethod/SearchForumInfoByID",
    method: "post",
    data
  });
}

// 查询相关论坛By、ID
export function SearchRelatedForumInfoByID(data) {
  return request({
    url: "/api/SystemMethod/SearchRelatedForumInfoByID",
    method: "post",
    data
  });
}
// 查询作者论坛
export function SearchAuthorForumInfoByUser(data) {
  return request({
    url: "/api/SystemMethod/SearchAuthorForumInfoByUser",
    method: "post",
    data
  });
}

// 查询课程是否已购买;
export function SearchClassBuyRecordingExistOrNot(data) {
  return request({
    url: "/api/SystemMethod/SearchClassBuyRecordingExistOrNot",
    method: "post",
    data
  });
}
// 查询课程是否已购买;
export function BuyClass(data) {
  return request({
    url: "/api/SystemMethod/BuyClass",
    method: "post",
    data
  });
}

// 上传 用户头像;
export function SaveUserAvatar(data) {
  return UploadOSSUtil.uploadOSS(data.raw);
  // return request({
  //   url: "/api/SystemMethod/SaveUserAvatar",
  //   headers: {
  //     "Content-Type": "multipart/form-data"
  //   },
  //   method: "post",
  //   data
  // });
}

// 更新用户;
export function UpdateUserInfo(data) {
  return request({
    url: "/api/SystemMethod/UpdateUserInfo",

    method: "post",
    data
  });
}

// 添加帖子;
export function AddPostInfo(data) {
  return request({
    url: "/api/ForumMethod/AddPostInfo",
    method: "post",
    data
  });
}

// 帖子图片存储;
export function ForumSaveImage(data) {
  return UploadOSSUtil.uploadOSS(data.raw);
  // return request({
  //   url: "/api/ForumMethod/ForumSaveImage",
  //   headers: {
  //     "Content-Type": "multipart/form-data"
  //   },
  //   method: "post",
  //   data
  // });
}

// 添加学习记录接口;
export function AddStudyyRecordingCount(data) {
  return request({
    url: "/api/ClassMethod/AddStudyyRecordingCount",
    method: "post",
    data
  });
}

// 增加视频浏览次数接口
export function AddBrowseCount(data) {
  return request({
    url: "/api/ClassMethod/AddBrowseCount",
    method: "post",
    data
  });
}

// 查询首页课程[NoLogin]
export function SearchHomeClassMeg(data) {
  return Promise.resolve({
    BusCode: 0,
    Code: 0,
    Data: [],
    Msg: null
  });
  // return request({
  //   url: "/api/SystemMethod/SearchHomeClassMeg",
  //   method: "post",
  //   data
  // });
}

// 查询个人学习记录
export function SearchStudyRecording(data) {
  return request({
    url: "/api/SystemMethod/SearchStudyRecording",
    method: "post",
    data
  });
}

//查询我的课程收藏
export function SearchMyClassFavoritesInfo(data) {
  return request({
    url: "/api/SystemMethod/SearchMyClassFavoritesInfo",
    method: "post",
    data
  });
}

//查询我的帖子收藏
export function SearchMyPostFavoritesInfo(data) {
  return request({
    url: "/api/SystemMethod/SearchMyPostFavoritesInfo",
    method: "post",
    data
  });
}

//课程收藏
export function ClassFavorites(data) {
  return request({
    url: "/api/ClassMethod/ClassFavorites",
    method: "post",
    data
  });
}
//取消课程收藏
export function CancelClassFavorites(data) {
  return request({
    url: "/api/ClassMethod/CancelClassFavorites",
    method: "post",
    data
  });
}



// WEBPACK FOOTER //
// ./src/api/public.js